var map = {
	"./": [
		"9923",
		9
	],
	"./config": [
		"d185",
		9
	],
	"./config.js": [
		"d185",
		9
	],
	"./en": [
		"cc06",
		9
	],
	"./en/": [
		"cc06",
		9
	],
	"./en/global": [
		"ba3b",
		3
	],
	"./en/global.json": [
		"ba3b",
		3
	],
	"./en/index": [
		"cc06",
		9
	],
	"./en/index.js": [
		"cc06",
		9
	],
	"./en/response": [
		"9ffc",
		3
	],
	"./en/response.json": [
		"9ffc",
		3
	],
	"./index": [
		"9923",
		9
	],
	"./index.js": [
		"9923",
		9
	],
	"./zh-TW": [
		"d913",
		9
	],
	"./zh-TW/": [
		"d913",
		9
	],
	"./zh-TW/global": [
		"ca9a",
		3
	],
	"./zh-TW/global.json": [
		"ca9a",
		3
	],
	"./zh-TW/index": [
		"d913",
		9
	],
	"./zh-TW/index.js": [
		"d913",
		9
	],
	"./zh-TW/response": [
		"a245",
		3
	],
	"./zh-TW/response.json": [
		"a245",
		3
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5892";
module.exports = webpackAsyncContext;